/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import VPagination from "@hennge/vue3-pagination";
import store from "../../store/index";
import ThresholdAddEditModal from "../RbqmThresholdManagement/ThresholdAddEditModal.vue";
import RbqmThresholdViewModal from "../RbqmThresholdManagement/RbqmThresholdViewModal.vue";

export default {
  name: "ThresholdList",
  components: { ThresholdAddEditModal, VPagination, RbqmThresholdViewModal },
  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,

      thresholdList: [],
      loading: false,

      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,

      SortProperty: "",
      SortOrder: 0,

      studyId: "",
      token: "",

      showThresholdModal: false,
      isEditMode: false,
      selectedThresholdData: null,
      showViewModal: false,
      viewType: "",
      viewData: null,
      searchField: {
        riskID: "",
        riskName: "",
      },
      getColumns: [],
      selectedColumns: [],
      selectedcolumnobj: {},
      showFilter: false,
      dropdownOpen: false,

    };
  },

  mounted() {
    window.addEventListener("studyIdChanged", () => {
      this.studyId = store.getters.getStudyIs;
      this.token = store.getters.getIdToken;
      this.currentPage = 1;
      this.getThresholdList();
      this.initializeColumns();
    });

    this.studyId = store.getters.getStudyIs;
    this.token = store.getters.getIdToken;
    this.getThresholdList();
    this.initializeColumns();
  },

  methods: {
    openCreateThreshold() {
      this.isEditMode = false;
      this.selectedThresholdData = null;
      this.showThresholdModal = true;
    },

    editThreshold(item) {
      console.log("Editing threshold:", item);
      this.isEditMode = true;
      this.selectedThresholdData = item;
      this.showThresholdModal = true;
    },

    closeThresholdModal() {
      this.showThresholdModal = false;
      this.selectedThresholdData = null;
    },

    async getThresholdList() {
      const idtoken = store.getters.getIdToken;
      this.loading = true;

      try {
        const res = await axios.get(
          `${this.baseurl}/forms/rbqm/getthreshold`,
          {
            params: {
              studyId: this.studyId,
              isActive: true,

              riskIndicatorId: this.searchField.riskID || undefined,
              riskName: this.searchField.riskName || undefined,

              pageindex: this.currentPage,
              pagesize: this.pageSize,

              SortProperty: this.SortProperty,
              SortOrder: this.SortOrder,
            },
            headers: {
              Authorization: `Bearer ${idtoken}`,
            },
          }
        );

        this.thresholdList = res.data.entities || [];
        this.totalCount = res.data.totalCount || 0;
        this.totalPages = Math.ceil(this.totalCount / this.pageSize);
        this.initializeColumns();

      } catch (err) {
        console.error("Error fetching thresholds", err);
        this.thresholdList = [];
      } finally {
        this.loading = false;
      }
    },


    sortSelected(property) {
      if (this.SortProperty === property) {
        this.SortOrder = this.SortOrder === 0 ? 1 : 0;
      } else {
        this.SortProperty = property;
        this.SortOrder = 0;
      }

      this.currentPage = 1;
      this.getThresholdList();
    },
    searchThresholds() {
      this.currentPage = 1;
      this.getThresholdList();
    },


    openViewModal(type, item) {
      this.viewType = type;
      this.viewData = item;
      this.showViewModal = true;
    },
    closeViewModal() {
      this.showViewModal = false;
      this.viewType = "";
      this.viewData = null;
    },
    async saveThreshold() {
      await this.getThresholdList();
    },
    async deleteThreshold(id) {
      if (!id) return;
      let idtoken = store.getters.getIdToken;
      const confirmDelete = confirm(
        "Are you sure you want to delete this threshold?"
      );
      if (!confirmDelete) return;

      try {
        await axios.delete(
          `${this.baseurl}/forms/rbqm/deletethreshold`,
          {
            params: { id },
            headers: {
              Authorization: `Bearer ${idtoken}`,
            },
          }
        );
        alert("Threshold deleted successfully");

        this.loadPage(this.currentPage);
      } catch (error) {
        console.error("Delete Threshold Error:", error);
        alert(
          error?.response?.data?.message ||
          "Failed to delete threshold"
        );
      }
    },
    initializeColumns() {
      const columns = [
        { key: "riskID", label: "Risk ID", default: true },
        { key: "riskName", label: "Risk Indicator", default: true },
        { key: "version", label: "Version", default: true },
        { key: "unit", label: "Unit", default: true },
        { key: "thresholds", label: "Thresholds", default: true },
        { key: "riskLevels", label: "Risk Levels", default: true },
        { key: "criticalDataPoints", label: "Critical Data Points", default: true },
      ];

      this.getColumns = columns.map(col => col.label);

      this.selectedColumns = columns
        .filter(col => col.default)
        .map(col => col.label);

      this.selectedcolumnobj = {};
      columns.forEach(col => {
        this.selectedcolumnobj[col.label] = col.default;
      });
    },

  }
};